import styled from "styled-components";

const ModalContainer = styled.div`
  position: fixed;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
`;

const ModalContent = styled.div`
 width: 480px;
 height: 230px;
  border: 10px solid #dddddd;
  border-radius: 30px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 45px;
  gap: 40px;
`;

const ModalTitle = styled.h2`
  font-size: 2.2rem;
  line-height: 30px;
  font-weight: 700;

  > span {
    color: #2aa4d5;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 15px;
`;

const Button = styled.button`
  width: 100px;
  height: 46px;
  border-radius: 10px;
  color: #fff;
  font-size: 2rem;
  font-weight: 700;
  cursor: pointer;
`;

const CancelButton = styled(Button)`
  background-color: #3d3d3d;
  &:hover {
    background-color: #2d2d2d;
  }
`;

const DeleteButton = styled(Button)`
  background-color: #00a7db;
  &:hover {
    background-color: #0087b3;
  }
`;

const ConfirmDeleteModal = ({
  onConfirm,
}) => {
  return (
    <ModalContainer>
      <ModalContent>
        <ModalTitle>
          <span>삭제</span> 하시겠습니까?
        </ModalTitle>
        <ButtonContainer>
          <DeleteButton onClick={() => onConfirm(true)}>확인</DeleteButton>
          <CancelButton onClick={() => onConfirm(false)}>취소</CancelButton>
        </ButtonContainer>
      </ModalContent>
    </ModalContainer>
  );
};

export default ConfirmDeleteModal;
